import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import ShadowButton from './ShadowButton';

export default function Kollegein() {
  return (
    <div className="wrapper max-w-5xl mx-auto px-4 my-6 sm:my-32 opacity-0 animate-fade-in-up animation-delay-400">
      {/* Hero Section */}
      <div className="flex flex-col md:flex-row gap-8 mb-12">
        <div className="md:w-2/3 w-full">
          <div className="flex items-center gap-3 mb-4">
            <div 
              className="w-12 h-12 flex items-center justify-center rounded text-white font-bold"
              style={{ backgroundColor: '#027D87' }}
            >
              KG
            </div>
            <h1 className="text-3xl font-bold">Kollegin</h1>
          </div>
          <p className="text-xl font-medium mb-6">
            Platform where doctors share real patient cases to interactively learn from each other.
          </p>
          
          <div className="flex flex-wrap gap-2 mb-8">
            {["MVP", "GTM", "Webflow", "React", "UX Design", "Health", "2024"].map(tag => (
              <span key={tag} className="px-3 py-1 bg-gray-100 text-gray-800 rounded-full text-sm">
                {tag}
              </span>
            ))}
          </div>
        </div>
        
        <div className="md:w-2/4 w-full">
          <img 
            src="assets/project-image-kollegein2.png" 
            alt="Kollege:in project" 
            className="w-full h-auto"
          />
        </div>
      </div>

      {/* Problem Section */}
      <div className="mb-12">
        <h2 className="text-2xl font-bold mb-4 flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 mr-2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 3v1.5M3 21v-6m0 0 2.77-.693a9 9 0 0 1 6.208.682l.108.054a9 9 0 0 0 6.086.71l3.114-.732a48.524 48.524 0 0 1-.005-10.499l-3.11.732a9 9 0 0 1-6.085-.711l-.108-.054a9 9 0 0 0-6.208-.682L3 4.5M3 15V4.5" />
            </svg>
          The challenge
        </h2>
        <p className="mb-4">
          Doctors were stuck learning from paper case studies, presentations or clunky websites. This meant:
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-2">
          <li>Wasted time navigating poor interfaces</li>
          <li>Missed opportunities for interactive learning</li>
          <li>No way to collect valuable user data</li>
        </ul>
      </div>
    {/* My Role Section - UPDATED */}
    <div className="mb-12">
        <h2 className="text-2xl font-bold mb-4">My role</h2>
        <p className="mb-4">
As venture architect and project lead, I led an 8-person team to build an interactive medical patient cases platform:
        </p>
        
        <div className="space-y-6">
        <ul className="list-disc pl-6 space-y-2">
        <li><strong>MVP</strong>: Launched first interactive patient case on Webflow from scratch</li>
        <li><strong>Iteration</strong>: Expanded to multiple cases and improved features based on how doctors used them</li>
        <li><strong>Growth</strong>: Rebuilt in React for more complex features and expanded to multiple medical fields</li>
      </ul>
        </div>
        <div className="md:w-2/4 w-full py-6 hidden">
          <img 
            src="assets/project-role-kollegein.png" 
            alt="Kollege:in project" 
            className="w-full h-auto"
          />
        </div>
      </div>

      {/* Process Images */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-12 hidden">
        <img 
          src="/api/placeholder/400/300" 
          alt="Process image 1" 
          className="w-full h-auto rounded-lg shadow-md"
        />
        <img 
          src="/api/placeholder/400/300" 
          alt="Process image 2" 
          className="w-full h-auto rounded-lg shadow-md"
        />
      </div>

      {/* Results Section */}
      <div className="mb-12">
        <h2 className="text-2xl font-bold mb-4">Results</h2>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
          <div className="bg-gray-50 p-4 rounded-lg flex flex-col justify-center items-center text-center">
            <p className="text-2xl font-bold text-teal-600">4.8/5</p>
            <p className="text-sm">Average doctor feedback</p>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg flex flex-col justify-center items-center text-center">
            <p className="text-2xl font-bold text-teal-600">5</p>
            <p className="text-sm">Oncology cases launched</p>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg flex flex-col justify-center items-center text-center">
            <p className="text-2xl font-bold text-teal-600">5</p>
            <p className="text-sm">Medical specialty teams onboarded</p>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg flex flex-col justify-center items-center text-center">
            <p className="text-2xl font-bold text-teal-600">1</p>
            <p className="text-sm">Satisfied client</p>
          </div>
        </div>
      </div>

      {/* Key Wins */}
      <div className="mb-12">
        <h2 className="text-2xl font-bold mb-4">Key wins</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="bg-gray-50 p-4 rounded-lg flex">
        <svg className="w-6 h-6 mr-3 text-green-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
        </svg>
        <p>Doctors actually used and liked it</p>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg flex">
        <svg className="w-6 h-6 mr-3 text-green-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
        </svg>
        <p>Nailed the Webflow-to-React transition</p>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg flex">
        <svg className="w-6 h-6 mr-3 text-green-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
        </svg>
        <p>Onboarded 5 additional teams</p>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg flex">
        <svg className="w-6 h-6 mr-3 text-green-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
        </svg>
        <p>Made everything secure and compliant</p>
          </div>
        </div>
      </div>

      {/* Technologies */}
      <div className="mb-12">
        <h2 className="text-2xl font-bold mb-4">Technologies</h2>
        <div className="flex flex-wrap gap-2">
          {["React", "Webflow", "Figma", "Miro"].map(tech => (
            <span key={tech} className="px-3 py-1 bg-gray-100 text-gray-800 rounded-full text-sm">
              {tech}
            </span>
          ))}
        </div>
      </div>

      <div className="my-24 bg-gray-100 p-12 rounded-lg">
  <h2 className="text-2xl text-center font-bold mb-4">Do you have a similar challenge and want to work with me?</h2>
  
  <div className="flex flex-col sm:flex-row gap-3 justify-center">
            {/* Using ShadowButton component */}
            <ShadowButton href="mailto:christophe@vaneerdt.be" fullWidth>
              Email me
            </ShadowButton>
            <ShadowButton href="tel:+32479706342" fullWidth>
              Call me
            </ShadowButton>
            <ShadowButton href="https://www.linkedin.com/in/cvaneerdt/" fullWidth>
              LinkedIn
            </ShadowButton>
          </div> 
     
</div>


    


      {/* Navigation */}
      <div className="flex justify-between items-center pt-6 border-t text-gray-600 border-gray-200">
        <Link to="/kollegein" className="flex items-center gap-2 text-gray-600 hover:text-gray-900">
          <span className="w-8 h-8 flex items-center justify-center rounded text-white font-bold text-sm" style={{ backgroundColor: '#027D87' }}>
            KG
          </span>
          <span>Current: Kollegin</span>
        </Link>
        
        <Link to="/monthlies" className="flex items-center gap-2 text-gray-600 hover:text-gray-900">
          <span>Next: Monthlies</span>
          <span className="w-8 h-8 flex items-center justify-center rounded bg-red-500 text-white font-bold text-sm">
            ML
          </span>
        </Link>
      </div>

    </div>
  );
}